import { Injectable } from '@angular/core';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { ArchivedFoldersService } from '../http/archived-folders.service';
import { IFolderViewerService } from '../http/folder-viewer-service.interface';
import { FoldersService } from '../http/folders.service';

@Injectable({
    providedIn: 'root',
})
export class FoldersServiceProvider {
    constructor(
        private foldersService: FoldersService,
        private archivedFoldersService: ArchivedFoldersService
    ) {}

    getService(type: ViewType): IFolderViewerService {
        if (type === ViewType.Box || type === ViewType.Workflow) {
            return this.foldersService;
        } else if (type === ViewType.ArchivingBox || type === ViewType.ArchivingWorkflow) {
            return this.archivedFoldersService;
        }
        throw new Error('Unknown service type');
    }
}
